/* Custom */
//Quantity plus minus boxes

function quantityMath(Element, addToValue)
{
  var input = Element.parent().parent().siblings('.quantity-wrap').find('.quantity');
  var textInt = parseInt(input.val());
  if(isNaN(textInt))
  {
    textInt = 1;
  }
  if ((textInt + addToValue) >= 1 ) {
    input.val(textInt + addToValue);
  }
  return false;
}

jQuery(function($) {
  $('.quantity-container .plus-wrap a.plus').click(function() { 
    quantityMath($(this), +1);
  });

  $('.quantity-container .minus-wrap a.minus').click(function() { 
    quantityMath($(this), -1);
  });

  $('.popup-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0,1], // Will preload 0 - before current, and 1 after the current image
      tCounter: '%curr% / %total%' // markup of counter
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: function(item) {
        return item.el.attr('title');
      }
    }
  });
});

var win = $(window);
var stickNav = function () {
  if(win.width() > 768) {
    $("#stickyNav").stick_in_parent({'parent': 'body'});
  } else {
    $("#stickyNav").stick_in_parent({'parent': 'body', 'offset_top': 0});
  }
}
$(function(){
  stickNav();
});
$( "#product_accordion" ).accordion({
  collapsible: true,
  heightStyle: "content",
  active: false
});
$( "#product_tabs" ).tabs();
if(win.width() > 768) {
  $( ".product_wrap" ).hover(
    function() {
      $( this ).addClass("activeState");
    }, function() {
      $( this ).removeClass( "activeState" );
    }
  );
}

jQuery(function($){
  var win	= $(window),
      document = $(document),
      container = $('.hp_content_wrap'),
      width = 1920,
      height = 700,
        winRatio = 1;
  winRatio = height/width;

  if ( win.width() >= 768 ) {
    container.height(win.width() * winRatio);
  }
  else {
    container.height(400);
  }
  win.resize(function() {
    if ( win.width() >= 768 ) {
      container.height(win.width() * winRatio);
    }
    else {
      container.height(400);
    }
  });
});

$('.open-popup-link').magnificPopup({
  type:'inline',
  midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});



// $('form.search-bar').hide();
// $(".search-button").click(function(e) {  
//   $('form.search-bar').show();
//   $(this).addClass('form-visible');
// });

// if($("#search").hasClass('.form-visible')) {
//   $('body').click(function() {
//     $("form.search-bar").hide();
//   });
// };

$('.product_title').matchHeight();

// window.SPR.$(document).bind('spr:reviews:loaded', function(e) {
//   console.log('test');
//   $('h3.spr-review-header-title').each(function() {
//     $(this).insertBefore($(this).siblings('.spr-starratings'));
//   });
// });

$(window).load(function(){
  if ($(window).width() <= 768){	
    $( "#filterAccordion-1" ).accordion({
      collapsible: true,
      active: false,
      header: "h4"
    });
    $( "#filterAccordion-2" ).accordion({
      collapsible: true,
      active: false,
      header: "h4"
    });
  };
});
function boardImageMove() {
  var board = $('.matcha-board-image'),
      active = 'active',
      mobileWrap = $('.mobileBoardImage');
  if (!mobileWrap.hasClass(active)) {
    var boardContent = board.html();
    mobileWrap.html(boardContent);
    board.empty();
    board.removeClass(active);
    mobileWrap.addClass(active);
  }
}

function boardImageUndo() {
  var board = $('.mobileBoardImage'),
      active = 'active',
      mobileWrap = $('.matcha-board-image');
  if (mobileWrap.hasClass(active)) {
    var boardContent = board.html();
    mobileWrap.html(boardContent);
    board.empty();
    board.removeClass(active);
    mobileWrap.addClass(active);
  }
}
function oracImagesMobile (){
  var image1 = $('.antioxidantImage1'),
      image2 = $('.antioxidantImage2'),
      src1mobile = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/antioxidant-circle-1-gray.png?v=139185128285283433981469046906",
      src2mobile = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/antioxidant-circle-2-gray.png?v=136693726299757179251469046917",
      src1desktop = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/orac.png?v=2437790586698724281468960795",
      src2desktop = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/orac-2.png?v=24434084678825433561468960801";
      image1.attr('src', src1mobile);
  image2.attr('src', src2mobile);
}

function oracImagesMobileUndo(){
  var image1 = $('.antioxidantImage1'),
      image2 = $('.antioxidantImage2'),
      src1mobile = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/antioxidant-circle-1-gray.png?v=139185128285283433981469046906",
      src2mobile = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/antioxidant-circle-2-gray.png?v=136693726299757179251469046917",
      src1desktop = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/orac.png?v=2437790586698724281468960795",
      src2desktop = "//cdn.shopify.com/s/files/1/1264/4789/t/2/assets/orac-2.png?v=24434084678825433561468960801";
      image1.attr('src', src1desktop);
  image2.attr('src', src2desktop);
}

function overlayMobile () {
  var overlay = $('#movingOverlay'),
      active = 'active',
      mobileWrap = $('#movingOverlayMobileContainer');
  if (!mobileWrap.hasClass(active)) {
    var overlayContent = overlay.html();
    mobileWrap.html(overlayContent);
    overlay.empty();
    overlay.removeClass(active);
    mobileWrap.addClass(active);
  }
}
function overlayMobileUndo () {
  var overlay = $('#movingOverlay'),
      active = 'active',
      mobileWrap = $('#movingOverlayMobileContainer');
  if (mobileWrap.hasClass(active)) {
    var overlayContent = mobileWrap.html();
    overlay.html(overlayContent);
    mobileWrap.empty();
    mobileWrap.removeClass(active);
    overlay.addClass(active);
  }
}

var win	= $(window),
    document = $(document),
    container = $('.newsletter-wrap'),
    width = 1920,
    height = 300,
    winRatio = 1;
winRatio = height/width;

if ( win.width() >= 769 ) {
  container.height(win.width() * winRatio);
}
else {
  container.height(400);
  overlayMobile();
  boardImageMove();
  oracImagesMobile();
}
win.resize(function() {
  if ( win.width() >= 769 ) {
    container.height(win.width() * winRatio);
    overlayMobileUndo();
    boardImageUndo();
    oracImagesMobileUndo();
  }
  else {
    container.height(400);
    overlayMobile();
    boardImageMove();
    oracImagesMobile();
  }
});

$('.customer-account a.account-wrap').click(function() {
  $('.accountHover').toggle();
});